
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/technicalOfficePubs/[category]",
      function () {
        return require("private-next-pages/[lang]/technicalOfficePubs/[category].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/technicalOfficePubs/[category]"])
      });
    }
  